import React, { useEffect, useState } from "react";

const SvgChevronRight = ({ viewBoxInc }) => {
  const [viewBoxDim, setViewBoxDim] = useState("0 0 0 0");

  useEffect(() => {
    const height = viewBoxInc.h;
    const width = viewBoxInc.w;

    setViewBoxDim(`0 0 ${width} ${height}`);
  }, [viewBoxInc]);

  return (
    <svg viewBox={viewBoxDim}>
      <defs>
        <filter id="shadowSVG">
          <feDropShadow dx="0.2" dy="0.4" stdDeviation="0.2" />
        </filter>
        <linearGradient id="Gradient1" x1="0" x2="0" y1="0" y2="1">
          <stop stopColor="#05f842" offset="10%" />
          <stop stopColor="#21749a" offset="70%" />
        </linearGradient>
      </defs>
      <path
        filter="url(#shadowSVG)"
        fill="url(#Gradient1)"
        id="chevron-right-1"
        height="100%"
        width="100%"
        strokeLinecap="butt"
        strokeLinejoin="bevel"
        stroke="url(#Gradient1)"
        strokeWidth={3}
        d="M 0 0, l 0 5, l 20 15, l -20 15, l 0 5, l 27 -20 z "
      ></path>
    </svg>
  );
};

export default SvgChevronRight;
